import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { AccountsService, LabVisitsService, type InternalUserComment, type InternalNote, type InternalNoteCreate } from "@/lib/api_client";
import { getAuthHeaders } from "@/lib/api";
import { fetchAll } from "./fetchAll";

export const useAllInternalUserComments = () =>
  useQuery({
    queryKey: ["internal-user-comments"],
    queryFn: () => fetchAll<InternalUserComment>(AccountsService.getApiInternalUserComments),
    staleTime: 60_000,
  });

export const useAllInternalNotes = () =>
  useQuery({
    queryKey: ["internal-notes"],
    queryFn: () => fetchAll<InternalNote>(LabVisitsService.getApiInternalNotes),
    staleTime: 60_000,
  });

export const useCreateInternalNote = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: InternalNoteCreate) => {
      const res = await LabVisitsService.postApiInternalNotes({
        body: data,
        headers: getAuthHeaders(),
      });
      if (!res.data) throw new Error("Failed to create internal note");
      return res.data as unknown as InternalNote;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["internal-notes"] });
    },
  });
};
